module.exports = __webpack_public_path__ + "img/active-session.13063c9e.svg";